import dalton from '../client';
import IdentityType from '../constants/IdentityType';

import { IdentityResponse } from '..';

export const DO_GET_IDENTITIES_ENDPOINT = '/core/api/1/identity/identities';
export const DO_GET_IDENTITIES_METHOD = 'GET';

/**
 * Return all identities for this user
 *
 * @param {IdentityType} [identityType] Type of Identity being searched for
 */
export default async function doGetIdentities(authorizationHeader: string | null, identityType?: IdentityType) {
    const resp = await dalton.request<IdentityResponse[]>({
        headers: {
            Authorization: authorizationHeader,
        },
        method: DO_GET_IDENTITIES_METHOD,
        params: {
            identityType,
        },
        url: DO_GET_IDENTITIES_ENDPOINT,
    });

    return resp.data;
}
